var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    {
      staticClass: "how-we-working-component",
      class: { "mobile-view": _vm.isMobileView }
    },
    [
      _c("h2", { staticClass: "title" }, [_vm._v("Как мы работаем")]),
      _vm._v(" "),
      _c("div", { staticClass: "steps-wrap" }, [
        _c("div", { staticClass: "step" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("p", { staticClass: "description" }, [
            _vm._v(_vm._s(_vm.textStepOne))
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "step step-bottom" }, [
          _vm._m(1),
          _vm._v(" "),
          _c("p", { staticClass: "description" }, [
            _vm._v(_vm._s(_vm.textStepTwo))
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "step" }, [
          _vm._m(2),
          _vm._v(" "),
          _c("p", { staticClass: "description" }, [
            _vm._v(_vm._s(_vm.textStepThree))
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "step step-bottom" }, [
          _vm._m(3),
          _vm._v(" "),
          _c("p", { staticClass: "description wide" }, [
            _vm._v(_vm._s(_vm.textStepFour))
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "step" }, [
          _vm._m(4),
          _vm._v(" "),
          _c("p", { staticClass: "description" }, [
            _vm._v(_vm._s(_vm.textStepFive))
          ])
        ])
      ]),
      _vm._v(" "),
      _vm._t("default")
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("picture", { staticClass: "work-icon" }, [
      _c("source", {
        attrs: {
          srcset:
            "/img/contact-work-step1.webp" +
            ", " +
            "/img/contact-work-step1@2x.webp" +
            " 2x",
          type: "image/webp"
        }
      }),
      _vm._v(" "),
      _c("source", {
        attrs: {
          srcset:
            "/img/contact-work-step1.png" +
            ", " +
            "/img/contact-work-step1@2x.png" +
            " 2x",
          type: "image/png"
        }
      }),
      _vm._v(" "),
      _c("img", {
        staticClass: "work-icon",
        attrs: {
          src: "/img/contact-work-step1.png",
          alt: "",
          loading: "lazy",
          width: "120",
          height: "120"
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("picture", { staticClass: "work-icon" }, [
      _c("source", {
        attrs: {
          srcset:
            "/img/contact-work-step2.webp" +
            ", " +
            "/img/contact-work-step2@2x.webp" +
            " 2x",
          type: "image/webp"
        }
      }),
      _vm._v(" "),
      _c("source", {
        attrs: {
          srcset:
            "/img/contact-work-step2.png" +
            ", " +
            "/img/contact-work-step2@2x.png" +
            " 2x",
          type: "image/png"
        }
      }),
      _vm._v(" "),
      _c("img", {
        staticClass: "work-icon",
        attrs: {
          src: "/img/contact-work-step2.png",
          alt: "",
          loading: "lazy",
          width: "120",
          height: "120"
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("picture", { staticClass: "work-icon" }, [
      _c("source", {
        attrs: {
          srcset:
            "/img/contact-work-step3.webp" +
            ", " +
            "/img/contact-work-step3@2x.webp" +
            " 2x",
          type: "image/webp"
        }
      }),
      _vm._v(" "),
      _c("source", {
        attrs: {
          srcset:
            "/img/contact-work-step3.png" +
            ", " +
            "/img/contact-work-step3@2x.png" +
            " 2x",
          type: "image/png"
        }
      }),
      _vm._v(" "),
      _c("img", {
        staticClass: "work-icon",
        attrs: {
          src: "/img/contact-work-step3.png",
          alt: "",
          loading: "lazy",
          width: "120",
          height: "120"
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("picture", { staticClass: "work-icon" }, [
      _c("source", {
        attrs: {
          srcset:
            "/img/contact-work-step4.webp" +
            ", " +
            "/img/contact-work-step4@2x.webp" +
            " 2x",
          type: "image/webp"
        }
      }),
      _vm._v(" "),
      _c("source", {
        attrs: {
          srcset:
            "/img/contact-work-step4.png" +
            ", " +
            "/img/contact-work-step4@2x.png" +
            " 2x",
          type: "image/png"
        }
      }),
      _vm._v(" "),
      _c("img", {
        staticClass: "work-icon",
        attrs: {
          src: "/img/contact-work-step4.png",
          alt: "",
          loading: "lazy",
          width: "120",
          height: "120"
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("picture", { staticClass: "work-icon" }, [
      _c("source", {
        attrs: {
          srcset:
            "/img/contact-work-step5.webp" +
            ", " +
            "/img/contact-work-step5@2x.webp" +
            " 2x",
          type: "image/webp"
        }
      }),
      _vm._v(" "),
      _c("source", {
        attrs: {
          srcset:
            "/img/contact-work-step5.png" +
            ", " +
            "/img/contact-work-step5@2x.png" +
            " 2x",
          type: "image/png"
        }
      }),
      _vm._v(" "),
      _c("img", {
        staticClass: "work-icon",
        attrs: {
          src: "/img/contact-work-step5.png",
          alt: "",
          loading: "lazy",
          width: "120",
          height: "120"
        }
      })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }